var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" If you have an questions or concerns, please contact us by clicking "),_c('a',{attrs:{"href":"https://simpleending.com/contact-us","target":"_blank"}},[_vm._v("here")]),_vm._v(". ")])
}]

export { render, staticRenderFns }